// extracted by mini-css-extract-plugin
export var container = "Consent-module--container--3pCVB";
export var content = "Consent-module--content--3ty2n";
export var btn = "Consent-module--btn--2ASyi";
export var decline = "Consent-module--decline--zzegL";